export enum LeaseBalanceStatus {
	Unset      = '',                // no amount has been specified
	PaidOnTime = 'paidOnTime',
	PaidLate   = 'paidLate',		// paid in full but not on-time
	Owing      = 'owing',
//	Inactive   = 'inactive', 		// not actually a status being used at this time
}
